import Link from 'next/link';
import Image from 'next/image';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'next-i18next';
import layoutUiState from '@features/layout/mobX/LayoutUiState';
import styles from '@features/navigation/components/Navigation/Navigation.styles';
import { BASE_PATH } from '@config/index';
import getImageQuality from '@utils/getImageQuality';
const SimpleNavigationDesktop = () => {
  const {
    setMenuDesktopHighlighted
  } = layoutUiState;
  const {
    t
  } = useTranslation('common');
  return <nav sx={styles.simpleNavigationContentContainer} aria-label="Navigation" tabIndex={0} role="menu" onMouseEnter={() => setMenuDesktopHighlighted(true)} onMouseLeave={() => setMenuDesktopHighlighted(false)} onFocus={() => setMenuDesktopHighlighted(true)} onBlur={() => setMenuDesktopHighlighted(false)}>
      <div sx={styles.menuLogoDesktop}>
        <Link href="/" prefetch={false}>
          <Image data-cy="logoIcon" height={52} width={70} src={`${BASE_PATH}/img/logo.svg`} quality={getImageQuality()} alt={t('logoIconAlt')} priority />
        </Link>
      </div>
    </nav>;
};
export default observer(SimpleNavigationDesktop);